export default __webpack_public_path__ + "static/media/invoice-img.0f2a2d7a.jpg";